var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 118,
    viewBox: "0 0 183 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.371 0.673462H5.7184C2.56021 0.673462 0 3.23368 0 6.39186V87.2655C0 90.4237 2.56021 92.9839 5.7184 92.9839H134.371C137.529 92.9839 140.089 90.4237 140.089 87.2655V6.39186C140.089 3.23368 137.529 0.673462 134.371 0.673462Z",
    fill: "#EAEBEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.371 0.673462H5.7184C2.5609 0.673462 0 3.23436 0 6.39186V12.0089H140.089V6.39186C140.089 3.23436 137.529 0.673462 134.371 0.673462Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.85 8.54752C117.969 8.54752 118.876 7.64036 118.876 6.52132C118.876 5.40228 117.969 4.49512 116.85 4.49512C115.731 4.49512 114.824 5.40228 114.824 6.52132C114.824 7.64036 115.731 8.54752 116.85 8.54752Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.42 8.54752C125.539 8.54752 126.446 7.64036 126.446 6.52132C126.446 5.40228 125.539 4.49512 124.42 4.49512C123.301 4.49512 122.394 5.40228 122.394 6.52132C122.394 7.64036 123.301 8.54752 124.42 8.54752Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.99 8.54752C133.109 8.54752 134.016 7.64036 134.016 6.52132C134.016 5.40228 133.109 4.49512 131.99 4.49512C130.871 4.49512 129.963 5.40228 129.963 6.52132C129.963 7.64036 130.871 8.54752 131.99 8.54752Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.655 112.227C160.655 115.041 154.093 117.326 146.005 117.326C137.917 117.326 131.354 115.041 131.354 112.227C131.354 109.413 137.917 107.128 146.005 107.128C154.093 107.128 160.655 109.413 160.655 112.227Z",
    fill: "#DFDFEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.672 36.4021C145.672 36.4021 141.243 36.8186 142.751 25.3424C144.186 14.446 149.68 6.49874 150.096 6.46497C150.096 6.46497 157.998 17.8004 153.045 27.6275C148.093 37.4546 145.672 36.3965 145.672 36.3965V36.4021Z",
    fill: "#08AF54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.942 19.8154C181.942 19.8154 171.794 31.9782 147.091 40.5502C147.091 40.5502 146.939 37.3083 155.483 29.4567C164.027 21.6108 183.129 16.0894 181.947 19.8154H181.942Z",
    fill: "#08AF54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.942 19.8153C181.942 19.8153 162.586 22.8546 147.091 40.5501C147.091 40.5501 145.566 42.4863 145.38 46.6512",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.111 43.3587C109.111 43.3587 119.259 55.5216 143.962 64.0935C143.962 64.0935 144.114 60.8516 135.57 53.0001C127.026 45.1542 107.924 39.6328 109.106 43.3587H109.111Z",
    fill: "#08AF54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.111 43.3588C109.111 43.3588 128.467 46.3981 143.962 64.0936C143.962 64.0936 145.487 66.0297 145.673 70.1947",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.816 68.2643C122.816 68.2643 129.565 73.7857 144.215 69.3674C144.215 69.3674 144.024 66.542 138.547 63.9248C133.065 61.3076 121.831 65.664 122.816 68.2643Z",
    fill: "#08AF54"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.816 68.2642C122.816 68.2642 133.983 61.6847 144.215 69.3674C144.215 69.3674 145.239 70.2904 145.695 73.735",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.331 39.2445C179.331 39.2445 172.239 58.3302 147.536 66.9022C147.536 66.9022 146.686 56.1296 155.23 48.278C163.774 40.4321 180.518 35.5186 179.336 39.2445H179.331Z",
    fill: "#08AF54"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.33 39.2443C179.33 39.2443 161.303 43.0997 147.536 66.9019C147.536 66.9019 145.954 69.7611 145.769 73.9261",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.446 42.25C141.446 42.25 139.369 45.627 131.185 44.5745C123.002 43.522 114.154 33.7906 108.627 35.5579C108.627 35.5579 122.219 30.6838 141.451 42.2444L141.446 42.25Z",
    fill: "#08AF54"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.148 88.6106C145.121 71.6637 144.26 51.2835 146.63 29.2766C146.63 29.2766 146.945 23.44 150.097 6.47058",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.31 35.1245C110.31 35.1245 124.054 31.7926 141.446 42.2557C145.662 44.7884 145.47 49.5669 145.2 53.2928",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.958 81.5977L134.726 110.933C134.726 112.728 139.808 114.186 146.078 114.186C152.348 114.186 157.43 112.728 157.43 110.933L162.198 81.5977H129.958Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.078 84.8508C154.981 84.8508 162.198 83.3943 162.198 81.5977C162.198 79.801 154.981 78.3445 146.078 78.3445C137.175 78.3445 129.958 79.801 129.958 81.5977C129.958 83.3943 137.175 84.8508 146.078 84.8508Z",
    fill: "#EAEBEC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3175 27.8597C79.8856 28.1186 87.8047 35.7844 88.3563 45.3413C88.6827 50.9584 86.5046 56.0746 82.8405 59.6823C82.3002 60.217 82.0469 60.9769 82.1764 61.7254L83.5553 69.8696L75.0847 64.9336C74.6006 64.6522 74.0322 64.5509 73.4862 64.6578C71.415 65.0743 69.2256 65.1531 66.963 64.8098C58.5992 63.5434 52.0704 56.6149 51.2993 48.1893C50.2637 36.9663 59.2352 27.5614 70.3175 27.8597Z",
    fill: "#BDBDBD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2931 54.7406C69.0342 54.7406 68.8372 54.6618 68.7021 54.4986C68.5671 54.3354 68.4995 54.1103 68.4995 53.8176C68.4995 53.5418 68.5727 53.3223 68.719 53.1478C68.8654 52.979 69.0567 52.8889 69.2987 52.8889C69.5745 52.8889 69.7715 52.9733 69.901 53.1309C70.0304 53.2941 70.0923 53.5193 70.0923 53.812C70.0923 54.0709 70.0248 54.2847 69.8841 54.4648C69.749 54.645 69.552 54.735 69.2931 54.735V54.7406ZM69.1355 48.3412C69.1186 47.8121 69.0961 47.2662 69.0792 46.709C69.0623 46.1518 69.0455 45.5946 69.0342 45.0374C69.0229 44.4802 69.0342 43.9117 69.0511 43.3264V36.5386H69.6983L69.7265 43.3264C69.7265 43.9117 69.7265 44.4802 69.7096 45.0374C69.6983 45.5946 69.6871 46.1518 69.6646 46.709C69.6421 47.2662 69.6252 47.8121 69.6027 48.3412H69.1355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidUrl);
export default __webpack_public_path__ + "static/media/invalid-url.436267bc.svg";
export { ForwardRef as ReactComponent };